export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=40c6c26c4283f9f9f207ed0569e5f25144672ef932&name=getWishlistServerAction!'